import { useLayoutEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Banner3 from "../../../assets/img/projects/LosPistoleros/Los_Pistoleros-Banner3.png";
import Banner4 from "../../../assets/img/projects/LosPistoleros/Los_Pistoleros-Banner4.png";

gsap.registerPlugin(ScrollTrigger);

function App() {
  const containerRef = useRef(null);
  const image1Ref = useRef(null);
  const image2Ref = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      // Animation de la première image (gauche) - arrive par la gauche
      gsap.fromTo(
        image1Ref.current,
        { x: -100, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: containerRef.current,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );

      // Animation de la deuxième image (droite) - arrive par la droite
      gsap.fromTo(
        image2Ref.current,
        { x: 100, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 1,
          delay: 0.3,
          ease: "power2.out",
          scrollTrigger: {
            trigger: containerRef.current,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <div className="LP-banner3" ref={containerRef}>
      <img ref={image1Ref} src={Banner3} alt="Banner" />
      <img ref={image2Ref} src={Banner4} alt="Banner" />
    </div>
  );
}

export default App;
